module.exports = __webpack_public_path__ + "img/tradein-full-2.cf18404e.jpg";